import {
  BottomSheetComponent,
  NavigationConfig,
  ParamListBase,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import InviteFriendsScreen from '../screens/InviteFriendsScreen';
import InviteStatusBottomSheet from './bottomsheets/InviteStatusBottomSheet';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'InviteFriends',
      options: { headerShown: true },
      component: InviteFriendsScreen,
    },
  ],
  FULL_SCREEN_MODALS: [],
};

const bottomSheets = {
  InviteStatus: InviteStatusBottomSheet,
};

registerBottomSheets('inviteFriends', bottomSheets);

registerNavigationHandlers<AppNavigatorParamsList, 'InviteFriends'>({
  InviteFriends(navigate) {
    navigate('/refer-a-friend');
  },
});

declare global {
  interface AppNavigatorParamsList extends ParamListBase {
    InviteFriends: undefined;
  }
}

declare global {
  interface RegisteredBottomSheets {
    inviteFriends: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
